import { cn } from '@/shared/lib/utils';

/** The iFlow globe mark — the brand sphere, legible on any background. */
export function IFlowMark({ className }: { className?: string }) {
  return (
    <img
      src="/iflow-mark.png"
      alt="iFlow"
      className={cn('size-7 object-contain', className)}
      draggable={false}
    />
  );
}

/** The full iFlow wordmark. Its lettering is dark, so it sits directly on the
 *  light surface. */
export function IFlowWordmark({ className }: { className?: string }) {
  return (
    <span className="inline-flex items-center rounded-lg px-2.5 py-1.5">
      <img
        src="/iflow-logo.png"
        alt="iFlow — API Analyzer"
        className={cn('h-6 w-auto object-contain', className)}
        draggable={false}
      />
    </span>
  );
}

/** Full lockup — collapsed shows just the globe mark, expanded the full wordmark. */
export function IFlowLockup({ collapsed = false }: { collapsed?: boolean }) {
  return collapsed ? <IFlowMark className="size-9" /> : <IFlowWordmark />;
}
